/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import logo from '../../Recursos/logo_blanco.svg'
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {AccountBalanceWallet} from '@mui/icons-material'
import {irUrl} from "../../Utilidades/irUrl";
import {URLBILLETERA} from "../../Constantes";

const BarraPc = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 4}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 6, sm: 6, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <img src={logo} width={sCell ? 100 : 114} height={'auto'}/>
                        </Grid>

                        <Grid container size={{xs: 6, sm: 6, md: 8}} sx={{justifyContent: 'flex-end'}}>
                            <Button
                                onClick={() => irUrl(URLBILLETERA)}
                                startIcon={<AccountBalanceWallet/>} sx={{px: 4.2, borderRadius: 1}}>Ingreso</Button>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default BarraPc